export default __webpack_public_path__ + "static/tools-0374242fdaaf439a118372be390900b9.png";